import api from 'api';

export const loadResults = api(
  'POST /api/players-activities/players-information'
);

export const bulkUpload = api(
  'POST /api/players-activities/players-information/upload'
);
